import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "components/Button/Button";
import { Loading } from "components/Loading/loading";
import { Textbox } from "components/Textbox/Textbox";
import { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { trans } from "utils/helpers";
import { putDefualtEmail, resetPasswordAsync } from "../../../api";


interface UserEmailConfirmProps{
selectedObj:any
reload?:any
}

export const EditEmailAndSendPassword = ({selectedObj,reload}:UserEmailConfirmProps) => {
    const [edit,setEdit]=useState<any>(false)
 
const handleSubmitForm=async(e)=>{
  e.preventDefault()
    try{
       let res;
      if
      (e.target.email?.value!=selectedObj?.Email){
         res=await putDefualtEmail(selectedObj?.Id,e.target.email?.value)
      }
      if((e.target.email?.value!=selectedObj?.Email && res.Data) || (e.target.email?.value==selectedObj?.Email )){
        resetPassword()
      }
    }catch(error){
      reload && reload()
    }
    

}
    const resetPassword = async() => {
        try {
            const res = await resetPasswordAsync(selectedObj?.Id)
        } catch (error) {
            
        }
        reload && reload()
      }

  return (
    <div className="card p-3">

 <form action="" onSubmit={handleSubmitForm}>
    <div className={`col-12 col-sm-4 row align-items-center`}>
        <div className="col">

    <Textbox
    textboxName="email"
    textboxType="email"
    labelText="email"
    defaultValue={selectedObj?.Email}
    mode={edit || !selectedObj?.Email?"create":'view'}
    required
    />
        </div>
        <div className="col-1 pt-1 px-0">
         <OverlayTrigger
                      key={"edit"}
                      placement="top"
                      
                      delay={{ show: 600, hide: 0 }}
                      overlay={
                        <Tooltip
                          className="tooltip "
                          id={`button-tooltip-${"reserve"}`}
                        >
                          {trans("edit")}
                        </Tooltip>
                      }
                    >
                      <button
                        name="edit"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault()
                          setEdit(true)
                        }}
                        className="btn btn-sm ms-1 btn-primary d-flex justify-content-center align-items-center customBtnSize p-1"
                      >
                        <FontAwesomeIcon
                          style={{ fontSize: "12px" }}
                          color={"white"}
                          icon={["fas", "edit"]}
                        />
                      </button>
                    </OverlayTrigger>
        </div>
    </div>
         <div className=" text-start">
                <Button
                       value={` ${trans('ResetPassword')}`}
                       customClass={"not-inherit"}
                       btnType="primary"
                       onClick={resetPassword}
                     />
                     <Button
                       value={`${trans('save')} ${trans('email')} ${trans('و')} ${trans('ResetPassword')}`}
                       customClass={"not-inherit"}
                       btnType="submit"
                     />
                
         </div>

 </form>

    </div>
  );
};
